import {BrandDiscount} from '@/model/brand-discount';
import {ArticlePrice, ProductPriceStock} from "@/model/product-price-stock";

export enum ShoppingCartStatus {
    ACTIVE = 'active'
}

export interface DeliveryOption {
    id: string;
    price: number;
    articleCode: string;
    description: string;
    selected: boolean;
}

export interface OrderRow {
    articleCode: string;
    quantity: number
}

export interface IProductPriceStockCollection {
    [productKey: string]: ProductPriceStock
}

export interface ShoppingCartPriceProperties {
    ecotaxTotal: number;
    bonusPoints: number;
    discount: number;
    shoppingCartId: number;
    subTotal: number;
    total: number;
    transportationCosts: number;
    transportationCostsOnRequest: boolean;
    products: IProductPriceStockCollection;
    orderBeforeTime: string;
}

export interface ProductPriceInformation {
    priceOnRequest: boolean;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
    unitDiscountPrice: number;
    discountPerUnit: number;
    brand: string;
    businessUnit: string;
    ecotax: number;
    awardedBrandDiscount: number | null;
    nextBrandDiscounts: BrandDiscount[] | null;
}



export class ShoppingCartPrice implements ShoppingCartPriceProperties {
    subTotal: number = 0;
    ecotaxTotal: number = 0;
    discount: number = 0;
    transportationCosts: number = 0;
    transportationCostsOnRequest: boolean = false;
    total: number = 0;
    bonusPoints: number = 0;
    shoppingCartId: number = 0;
    products = <IProductPriceStockCollection>{};
    orderBeforeTime: '' = '';
    orderTotalItems: number = 0;
    deliveryOptionsCosts: number = 0;
}


export interface ShoppingCartProperties {
    accountNumber: string | number;
    customerReference: string;
    deliveryName: string;
    deliveryCity: string;
    deliveryCountry: string;
    deliveryStreet: string;
    deliveryZipCode: string;
    deliveryOptions: DeliveryOption[];
    remark: string;
    orderedBy: string;
    id: number;
    items: OrderRow[];
    deliveryContactName: string;
    deliveryPhone: string;
}

export class ShoppingCart implements ShoppingCartProperties {
    id: number = 0;
    created: Date = new Date();
    updated: Date = new Date;
    status: ShoppingCartStatus = ShoppingCartStatus.ACTIVE;
    accountNumber: number = 0;
    customerReference: string = '';
    deliveryName: string = '';
    deliveryStreet: string = '';
    deliveryCity: string = '';
    deliveryCountry: string = '';
    deliveryZipCode: string = '';
    remark: string = '';
    orderedBy: string = '';
    deliveryOptions: DeliveryOption[] = [];
    items: OrderRow[] = [];
    deliveryContactName: string = '';
    deliveryPhone: string = '';
    private readonly price: () => Promise<ShoppingCartPrice>;
    private shoppingCartPrice: ShoppingCartPrice | null = null;

    constructor(data: { [key: string]: any }, shoppingCartPricePromise: () => Promise<ShoppingCartPrice>) {
        Object.keys(data)
            .filter(key => data[key] != null && (<any>this)[key] != null)
            .forEach(key => (<any>this)[key] = data[key]);

        this.price = shoppingCartPricePromise;
    }

    getPrice() {
        return this.price();
    }

    setShoppingCartPrice(shoppingCartPrice: ShoppingCartPrice) {
        this.shoppingCartPrice = shoppingCartPrice;
    }

    getShoppingCartPrice(): ShoppingCartPrice | null {
        return this.shoppingCartPrice;
    }
}

export interface Sale {
    salesID: string
}

export interface Address {
    name: string,
    city: string,
    country: string,
    street: string,
    postalcode: string
}
